export default __webpack_public_path__ + "static/media/pinterest_veryDarkGrey.3ac04a3d.svg";